import { UiEvent } from '../utils/ui-event';
import { PTR } from '@parship/psg-interfaces';

export class Heartbeat {
	private userHasInteracted: boolean;
	private readonly pingInterval: number;
	private readonly uuid: string;
	private timeoutId: number = null;
	private ptr: PTR;
	private pingCount: number;

	constructor(interval: number = 10000) {
		this.userHasInteracted = true;
		this.pingInterval = interval;
		this.ptr = window.ptr;
		this.pingCount = 0;

		this.uuid = this.getUUID();

		document.addEventListener('visibilitychange', () => this.onVisibilityChange());
		document.addEventListener('mousemove', () => this.onUserInteraction());
		document.addEventListener('scroll', () => this.onUserInteraction());
		document.addEventListener('click', () => this.onUserInteraction());
		document.addEventListener('touchmove', () => this.onUserInteraction());
		document.addEventListener('resize', () => this.onUserInteraction());

		this.sendPing();
	}

	private onUserInteraction(): void {
		this.userHasInteracted = true;
	}

	private onVisibilityChange(): void {
		if (document.visibilityState === 'hidden') {
			window.clearTimeout(this.timeoutId);
		}
	}

	private getUUID(): string {
		if (sessionStorage.getItem('crm-lp-uuid') === null) {
			sessionStorage.setItem('crm-lp-uuid', window.crypto.randomUUID());
		}

		return sessionStorage.getItem('crm-lp-uuid');
	}

	private sendPing(): void {
		if (this.userHasInteracted) {
			UiEvent.trackUIEvent(
				this.ptr?.landing_page || '',
				this.uuid,
				'ping',
				(this.pingCount * 10).toString()
			);

			this.userHasInteracted = false;
			this.pingCount++;
			this.timeoutId = window.setTimeout(() => {
				this.sendPing();
			}, this.pingInterval);
		}
	}
}
